import { itx } from "../translationItx/itx";

export default function ErrorFallback(params: { error: any; resetErrorBoundary: () => void }) {
    const { error, resetErrorBoundary } = params;

    const at = error?.stack?.split("\n")[1]?.trim() || "";

    return (
        <div role="alert">
            <p>{itx("navigationTreeNode.wentWrong", "Something went wrong:")}</p>
            <pre>{error.message}</pre>
            <pre>{at}</pre>

        </div>
    );
}